export const LANE_NAMES = [
  "Orcas",
  "Humpbacks",
  "Sharks",
  "Otters",
  "Dolphins",
  "Tortugas",
];

export const INTERVAL_BASE = [
  60 + 20,
  60 + 30,
  60 + 40,
  60 + 50,
  120,
  120 + 15,
];

export const BASE_LENGTH = 3;
export const BASE_DISTANCE = 100;
export const DISTANCE_UNIT = "yd";

// Break between WorkoutList
export const REPEAT_BREAK_SEC = 20;
export const WORKOUT_BREAK_SEC = 40;
export const GROUP_BREAK_SEC = 60;

// Input size
export const UNIT_W = 16;
